import { QueryClient } from 'react-query';
import { EmailTemplateMutations, EmailTemplateQueries } from '@frontend/api-email-template';

/** Invalidates all email template list queries (all-templates, system templates and org templates). */
export function invalidateEmailTemplateLists(queryClient: QueryClient) {
  const queryKeys = queryClient
    .getQueriesData<EmailTemplateMutations.PaginationData>(EmailTemplateQueries.keys.listEmailTemplatesBase())
    .map(([key]) => key);
  queryKeys.forEach((key) => queryClient.invalidateQueries(key));
  queryClient.invalidateQueries(EmailTemplateQueries.keys.listAllEmailTemplatesBase());
  queryClient.invalidateQueries(EmailTemplateQueries.keys.listEmailTemplatesBase());
  queryClient.invalidateQueries(EmailTemplateQueries.keys.listSystemTemplatesBase());
}
